import type { OnboardingStatusDto } from '@af/shared';

/**
 * What a screen needs before its main action makes sense, in dependency order:
 * a provider → an enabled model → an agent. Derived from the onboarding counts (no stored flag).
 */
export type SetupNeed = 'model' | 'agent';
export type SetupBlocker = 'provider' | 'models' | 'agent';

export function setupBlocker(c: OnboardingStatusDto | undefined, need: SetupNeed): SetupBlocker | null {
  if (!c) return null;
  if (c.providers === 0) return 'provider';
  if (c.enabledModels === 0) return 'models';
  if (need === 'agent' && c.agents === 0) return 'agent';
  return null;
}
